import { render, staticRenderFns } from "./highlight-text.vue?vue&type=template&id=ec03f55e&"
import script from "./highlight-text.vue?vue&type=script&lang=js&"
export * from "./highlight-text.vue?vue&type=script&lang=js&"
import style0 from "./highlight-text.vue?vue&type=style&index=0&id=ec03f55e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports